import * as Yup from "yup";

export const signup_model = () => ({
  "appName":"realbooks",
  "email_id":null,
  "password":null,
  "name":null,
  "mobile_no":null,
  "verification_code":null,
  "comp_name":null,
  "comp_short_name":null,
  "country":null,
  "state":null,
  "city":null,
  "gstin_no":null,
  "currency":null,
  "terms_and_condition":null,
  "dtCreate":null,
  "dtUpdate":null,
  "lastUsedInDays":null,
  "referral_code":null,
  "project_name":null,
  "industry_other":null
});
  
  export const signup_Step_OneSchema = Yup.object().shape({
    email_id: Yup.string().required("Email is required").email("Email is invalid")
  });